// extracted by mini-css-extract-plugin
module.exports = {"loading-text":"FallBackSpinner_loading-text__1jV65"};